import { User } from "../../../core/internal/model/model"
import { UserContext } from "../../../core/internal/user/UserContext"
import { WorkspaceEvaluationContext } from "../../../core/internal/workspace/evaluation/WorkspaceEvaluationContext"

/**
 * Remote-mode user context: only the identifying user. In remote mode the server owns evaluated
 * properties (they are sent via the evaluate request's `operations`), so local properties are
 * stripped from the context — the context exists to key the per-user evaluation by identifiers.
 */
export class RemoteUserContext implements UserContext {
  private constructor(readonly user: User) {}

  static from(user: User): RemoteUserContext {
    return new RemoteUserContext(sanitize(user))
  }

  evaluationKey(): string {
    return WorkspaceEvaluationContext.keyOfUser(this.user).hashKey()
  }
}

const sanitize = (user: User): User => {
  if (!user.properties || Object.keys(user.properties).length === 0) {
    return user
  }
  return { ...user, properties: {} }
}
